export interface IWidgetService {
  addReadKeyListener(): void
}

export class WidgetService implements IWidgetService {
  constructor(
    private readonly widget: Record<string, any>,
    private readonly callbackAfterAuth: (certs: Record<string, any>[]) => void,
  ) {}

  public addReadKeyListener(): void {
    void (async () => {
      try {
        const certificates = await this.widget["ReadPrivateKey"]();
        this.callbackAfterAuth(certificates);
      } catch (e) {
        throw new Error("Виникла помилка при зчитуванні ос. ключа");
      }
    })();
  }
}
